/* UrlLink
 * to change the UrlLink type add in the UrlLink prop: infotext ,without prop it's link underline text
 *   <UrlLink to='/url' infotext>Terms of Service</UrlLink>
 *   <UrlLink to='/url'>Forgot your password?</UrlLink> with underline text
 */
import React from 'react';
import { Link } from 'react-router-dom';
import classes from './UrlLink.module.css';
import { string } from 'prop-types';

const urlLink = (props) => {
  let styles = props.infotext ? classes.Infotext : classes.UrlLink;

  let location = props.to;
  if (typeof props.to === 'string') {
    const [pathname, search] = props.to.split('?');
    location = search ? { pathname, search } : { pathname };
  }

  if (props.gaData) {
    location.state = props.gaData;
  }

  return (
    <Link to={location} className={styles} style={props.style}>
      {props.children}
    </Link>
  );
};
export default urlLink;
